import React, { Component } from 'react';


const MAX_DICTIONARY = 20;

class Practice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "in_eng" : " ",
      "term" : "fetching term...",
      "gender": "female",
      "term_id": "0",
      "show_eng": false,
      "animating": true,
      "error" : false
    };

    this.update_card();
  }

  gen_new_number(){
    let new_number = Math.floor(Math.random() * MAX_DICTIONARY) + 1;
    console.log("generating new number... ", new_number)
    if (new_number === Number(this.state.term_id)) {
      return this.gen_new_number();
    }

    return new_number;
  }
  show_error = () => {
    this.setState({"error": true});
    let _this = this;
    setTimeout(function(){ _this.setState({"error": false}); }, 1000);
  }

  update_card = () => {
    let r_elem = this;
    if (this.state.animating === false) {
      this.setState({"animating": true});
    }

    let new_number = this.gen_new_number();
    this.props.apiget(new_number).then(function(res) {
      console.log("The results are in!", res);
      if (res === {} || res === null) {
        return r_elem.update_card();
      }
      r_elem.setState({
        "in_eng" : res.in_eng,
        "term" : res.term,
        "gender": res.gender,
        "term_id": res.term_id,
        "animating": false,
      })
    });
  }

  guessgender = (gender) => {
    if (gender === this.state.gender) {
      this.update_card();
    } else {
      this.show_error();
    }
  }

  showTranslation = ()  => {
    console.log("Show eng is currently....", this.state.show_eng);
    let show_translation = this.state.show_eng;
    this.setState({"show_eng": !show_translation})
  }

  render() {
    return (
      <div>
        <h2>Select the gender of the word below</h2>
        <div className={"card animate " + (this.state.error ? "shake" : "")}>
          <h3 className={'quiz-term animate ' + (!this.state.animating ? "fade-in-up" : "fade-out-down")}>
            {this.state.term}<br />
            <span className={"animate hidden-default " + (this.state.show_eng ? "fade-in-up" : "fade-out-down")}>
              &nbsp;{this.state.in_eng}&nbsp;
            </span>
          </h3>
          <button className="button" onClick={this.showTranslation}>
            {this.state.show_eng ? "Hide" : "Show"} Translation
          </button>
        </div>
        <button className="button male" onClick={() => this.guessgender("male")}>
          Masc
        </button>
        <button className="button female" onClick={() => this.guessgender("female")}>
          Fem
        </button>
        <div className="backbutton-holder">
          <a className="button gray" href="/choose-mode">
            &larr; Back to Practice Modes
          </a>

        </div>
      </div>
    );
  }
}

export default Practice;
